import bootstrapBundleMin from '../../../public/lib/js/bootstrap.bundle.min.js';
import "bootstrap-icons/font/bootstrap-icons.css";

// ! OKTA-AUTH
import {
    authClient,
    appState,
    logout
} from '../../okta-auth.js';

import './navbar.css';

// Responsive menu/navbar functions
$(window).on("load", function() {

    // Ensure visible on window resize
    $(window).on("resize", function() {
        if ($(".form-actions.toolbar:hidden").length > 0) {
            $('.form-actions.toolbar').show();
        }
        if ($(".navbar:hidden").length > 0) {
            $('.navbar').show();
        }
    });

    // This is required as the navbar will load AFTER the `renderApp()`
    // call fires
    authClient.authStateManager.subscribe(function(authState) {
        const welcomeUser = $('#welcome-user-id');
        welcomeUser.text(`Welcome : ${appState.userInfo.email}`);
    });
});

/**
 * Programmatically closes the bootstrap 'collapse' dropdown
 * https://getbootstrap.com/docs/5.0/components/collapse/#options
 */
export function closeNavbar() {
    const navbarCollapse = $("#navbar-collapse");
    const bsCollapse = bootstrapBundleMin.Collapse.getInstance(navbarCollapse);
    if(bsCollapse) bsCollapse.hide();
}

function attachBtnListeners() {

    // INLINE BUTTONS
    $("#home-btn-id").on("click", function() {
        window.location.href = "index.html";
    });

    $("#weather-viewer-btn-id").on("click", function() {
        window.location.href = "fwe.html";
    });

    $("#briefing-btn-id").on("click", function() {
        window.location.href = "briefing.html";
    });

    $('#fdr-nsw-btn-id').on("click", function() {
        window.location.href = "district.html";
    });

    $('#prelim-btn-id').on("click", function() {
        window.location.href = "preliminary.html";
    });

    $('#point-forecast-btn-id').on("click", function() {
        window.location.href = "extract.html";
    });

    $('#about-btn-id').on("click", function() {
        window.location.href = "about.html";
    });

    $('#logout').on('click', function() {
        logout();
    })

    // DROPDOWN BUTTONS (all of these are aliases that click the inline buttons)
    $('#collapse-home-btn-id').on("click", function() {
        $("#home-btn-id").trigger("click");
    });

    $('#collapse-weather-viewer-btn-id').on("click", function() {
        $("#weather-viewer-btn-id").trigger("click");
    });

    $('#collapse-briefing-btn-id').on('click', function() {
        $('#briefing-btn-id').trigger('click');
    });

    $('#collapse-fdr-nsw-btn-id').on('click', function() {
        $('#fdr-nsw-btn-id').trigger('click');
    });

    $('#collapse-prelim-btn-id').on('click', function() {
        $('#prelim-btn-id').trigger('click');
    });

    $('#collapse-point-forecast-btn-id').on('click', function() {
        $('#point-forecast-btn-id').trigger('click');
    });

    $('#collapse-about-btn-id').on('click', function() {
        $('#about-btn-id').trigger('click');
    });

    $('#collapse-logout').on('click', function() {
        $('#logout').trigger('click');
    })
}

export function attachDropdownListeners() {
    // Attach a listener to the navbar button for onclick behaviour
    $('#navbar-dropdown-btn').on("click", function() {
        const navbarCollapse = $("#navbar-collapse");
        var bsCollapse = bootstrapBundleMin.Collapse.getInstance(navbarCollapse);
        if(bsCollapse) bsCollapse.toggle();
        else {
            bsCollapse = new bootstrapBundleMin.Collapse(navbarCollapse, {
                toggle: true
            });
        }
    });

    // Attach a listener for the 'danger ratings' button
    $('#danger-ratings-btn').on("click", function() {
        const dangerRatingsCollapse = $("#danger-ratings-nested");
        var bsNavCollapse = bootstrapBundleMin.Collapse.getInstance(dangerRatingsCollapse);
        
        if(bsNavCollapse) bsNavCollapse.toggle();
        else {
            bsNavCollapse = new bootstrapBundleMin.Collapse(dangerRatingsCollapse, {
                toggle: true
            });
        }
    });

    // Also attach a listener for the 'danger ratings' button that sits
    // in the nested dropdown menu
    $('#collapse-danger-ratings-btn').on("click", function() {
        const collapseDangerRatingsCollapse = $("#collapse-danger-ratings-nested");
        var bsNavCollapse = bootstrapBundleMin.Collapse.getInstance(collapseDangerRatingsCollapse);

        if(bsNavCollapse) bsNavCollapse.toggle();
        else {
            bsNavCollapse = new bootstrapBundleMin.Collapse(collapseDangerRatingsCollapse, {
                toggle: true
            });
        }
    })

    // Attach all the listeners for the buttons:
    attachBtnListeners();
}

// Function to collapse the navbar
function collapseNavbar() {
    const navbarCollapse = $("#navbar-collapse");
    var bsCollapse = bootstrapBundleMin.Collapse.getInstance(navbarCollapse[0]);
    if (bsCollapse && bsCollapse._isShown) {
        bsCollapse.hide();
    }
}

// Add event listener for window resize
$(window).on("resize", function() {
    collapseNavbar();
});
